var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('book-carousel',{attrs:{"books":_vm.randBooks}}),_c('div',{staticClass:"text-h3 py-4"}),_c('book-view',{attrs:{"books":_vm.books,"pagination":_vm.pagination},on:{"update":({ order, nextPage }) => _vm.getBooks(nextPage, this.pageSize, order)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }